import { DATETIME_ELEMENT_STYLES, dateTimeFormat } from '@fiverr-private/localization';
import { remoteDate } from '@fiverr-private/futile';
import { EVENING_HOUR, MORNING_HOUR } from '../../constants';

const getFormattedTime = (date) => dateTimeFormat({
    value: date,
    options: {
        hour: DATETIME_ELEMENT_STYLES.TWO_DIGIT,
        minute: DATETIME_ELEMENT_STYLES.TWO_DIGIT
    }
});

const useRemoteDate = ({ utcOffset: rawUtcOffset }) => {
    const utcOffset = parseInt(rawUtcOffset, 10);
    const date = remoteDate(utcOffset);

    if (isNaN(utcOffset)) {
        const date = new Date();
        const formattedTime = getFormattedTime(date);

        return {
            isNight: false,
            date,
            formattedTime
        };
    }

    if (!date || isNaN(date.getHours())) {
        const fallbackDate = new Date();
        const formattedTime = getFormattedTime(fallbackDate);

        return {
            isNight: false,
            date: fallbackDate,
            formattedTime
        };
    }

    const formattedTime = getFormattedTime(date);

    const hours = date.getHours();
    const isNight = !(hours >= MORNING_HOUR && hours < EVENING_HOUR);

    return { date, formattedTime, isNight };
};

export default useRemoteDate;
